const options = { year: 'numeric', month: 'long', day: 'numeric' };

const formatDate = (date) => {
  return new Date(date).toLocaleDateString('en-US', options);
};


const findDate = (flag, date, membershipInfo) => membershipInfo.flags.filter(e => e.display_name === flag)[0][date];

const flagsName = {
  has_box_subscription: 'has_box_subscription',
  canceled: 'canceled',
  has_refill_subscription: 'has_refill_subscription',
  expired_box_subscription: 'expired_box_subscription',
  trial: 'trial',
}

const labels = {
  expired: ['Membership Expired: ', 'Member Since: '],
  canceled: ['Membership Expires: ', 'Member Since: '],
  refill: ['Member Since: '],
}

export const getProfileDates = (membershipInfo) => {
  try {
    let datesInfo = [];
    if (membershipInfo?.flags && membershipInfo?.flags.length === 0) return datesInfo;

    if (membershipInfo?.membership_state === 'expired') {
      const expiredFlag = membershipInfo?.flags?.find(e => e.display_name === flagsName.expired_box_subscription);
      if (expiredFlag) {
        datesInfo = [
          {
            label: labels.expired[0],
            date: formatDate(expiredFlag.effective_from),
          },
          {
            label: labels.expired[1],
          }
        ]
      }
      else datesInfo = [
        {
          label: labels.expired[0],
          date: formatDate(findDate(flagsName.trial, 'effective_to', membershipInfo)),
        },
        {
          label: labels.expired[1],
        }
      ]
    }

    if (membershipInfo?.membership_state === 'canceled') {
      const isRefill = membershipInfo?.flags?.find(e => e.display_name === flagsName.has_refill_subscription);
      datesInfo = [
        {
          label: labels.canceled[0],
          date: formatDate(findDate(
            isRefill ? flagsName.has_refill_subscription : flagsName.has_box_subscription,
            'effective_to', membershipInfo
          )),
        },
        isRefill ?
          {
            label: labels.canceled[1],
            date: formatDate(findDate(flagsName.has_refill_subscription, 'effective_from', membershipInfo)),
          }
          :
          {
            label: labels.canceled[1],
          }
      ]
    }

    if (membershipInfo?.isRefillSubscription) {
      datesInfo = [
        {
          label: labels.refill[0],
          date: formatDate(findDate(flagsName.has_refill_subscription, 'effective_from', membershipInfo)),
        }
      ]
    }

    return datesInfo;
  } catch (error) {
    return [
      {
        label: labels.refill[0]
      }
    ];
  }
}
